/* eslint-disable react/no-unused-prop-types */
/* note: the above suppression is because our FormatWrapper component does not directly use the props but uses object spread, and the intellisense is not intelligent enough */

import React from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import {
  Card, 
  CardHeader, 
  CardText
} from 'material-ui/Card';

const createRow = (
  code,
  description,
  caption,
  sequenceNumber,
  occurrence,
  featureValue,
  categoryCode
) => {
  return {
    code,
    description,
    caption,
    sequenceNumber,
    occurrence,
    featureValue,
    categoryCode,
  };
};

const FeaturePanel = (props) => {
  const { customerInfo } = props;

  if (!customerInfo) {
    return <h6 className="padx2">No Account Information Found</h6>;
  }

  const customer = customerInfo || new Immutable.Map();

  const occurrenceFeatures =
    customer.get("occurrenceFeatures") || new Immutable.List();
  
  return (
    <div>
      {occurrenceFeatures.map((row, index) => (
        <div key={`feature-card-${index}`} style={{margin:"20px"}}>
          <Card>
            <CardHeader
              title={row.get("description")}
              subtitle={row.get("caption") === row.get("description")
                          ? null
                          : row.get("caption")
                        }
            />
            <CardText>
              Value: {row.get("featureValue") === ""
                ? `N/a, Occurence: ${row.get("occurrence")}`
                : row.get("featureValue")
              }
            </CardText>
          </Card>
        </div>
      ))}
    </div>
  );
};

FeaturePanel.propTypes = {
  customerInfo: PropTypes.object,
};

export default FeaturePanel;



// WEBPACK FOOTER //
// ./src/components/account/FeaturePanel.js